import logo from './logo.svg';
import './App.css';
import { useEffect, useState } from 'react';
import FlipCountdown from '@rumess/react-flip-countdown';
import logoNanodoge from './img/dogenano.png'
import logoTwitter from './img/twitter-icon.svg'
import dogenanoAirdrop from './img/dogenano-airdrop.png'
import discord from './img/discord.png'
import './App.css';
import { Button, Card, Input, Collapse , Form, Tabs, Divider} from 'antd';
import {
  DoubleRightOutlined
} from '@ant-design/icons';
import React, { Component }  from 'react';
import Claim from './Claim';
import ClaimTable from './ClaimTable';
import FAQ from './FAQ';
import Stats from './Stats';
import Footer from './Footer';
import { Link } from 'react-router-dom';
import dogeNanoDiscord from './img/dogenano-discord.png'

function Countdown() {
  useEffect(() => {
    document.title = "DogeNano - Airdrop to Dogecoin holders"
  }, [])

  const { TabPane } = Tabs;


  return (
    <div className="App" style={{backgroundColor: "#dcecff"}}>
    <div >
    <div style={{textAlign: "center"}}>
    <Link to={'/'}><img src={dogenanoAirdrop} alt="Discord" width={128} style={{marginTop: 48, marginBottom: 32}} /></Link>
    </div>
        {/* <h1 style={{paddingTop: 64, color: "black", textAlign: "center"}}></h1> */}
        <div style={{maxWidth: "600px", marginRight: "auto", marginLeft: "auto"}}>
<Claim />
<Card style={{marginTop: 8}} title="Distribution schedule">
<div>
  <ul>
    <li>4/20/2022 4:20:00 PM UTC - 1 DOGE = 10 XDG / Claim not capped</li>
    <li>3/20/2023 4:20:00 PM UTC - 1 DOGE = 10 XDG / claim capped at 2,000,000 XDG</li>
    <li>4/20/2023 4:20:00 PM UTC - 1 DOGE = 5  XDG / Claim capped at 1,000,000 XDG per address</li>
    <li>4/20/2024 4:20:00 PM UTC - 1 DOGE = 1  XDG / Claim capped at 200,000 XDG</li>
    <li><b>4/20/2025 4:20:00 PM UTC - End, final burn, all xdg remaining burned</b></li>
  </ul>
</div>
{/* <div style={{}}>
    Time before next step:
</div> */}

</Card>

<Divider />
<FAQ />
  {/* <Stats /> */}
 
    </div>
    </div>
    <Divider />
<Footer />
    </div>
  );
}

export default Countdown;
